const vertexShader = `uniform vec3 uBoxHalfSizeList[MAX_BOX_LIST];
uniform int uNumActiveBoxList;
uniform sampler2D uMatrixTexture;
uniform float fSize;
uniform float fMatrixTextureHeight;
uniform bool bIsMainView;

varying float vBoxIndexFloat;
varying float vIsExtendedPoint;
varying float vIsExtendedEqualZAxis;

attribute float intensity;
varying float vIntensityFloat;

mat4 getMatrix(int index) {
  // RGBA 텍스처에서 각 픽셀은 4개의 float 값을 저장
  // 4x4 행렬(16개 값)은 4개의 픽셀로 저장
  // 텍스처 너비는 4, 각 행렬은 텍스처의 한 행에 저장
  float row = float(index);
  float textureWidth = 4.0;
  
  // 각 픽셀에서 행렬의 한 열(column)을 가져옴
  vec2 uv1 = vec2(0.5 / textureWidth, (row + 0.5) / fMatrixTextureHeight);
  vec4 col0 = texture2D(uMatrixTexture, uv1);
  
  vec2 uv2 = vec2(1.5 / textureWidth, (row + 0.5) / fMatrixTextureHeight);
  vec4 col1 = texture2D(uMatrixTexture, uv2);
  
  vec2 uv3 = vec2(2.5 / textureWidth, (row + 0.5) / fMatrixTextureHeight);
  vec4 col2 = texture2D(uMatrixTexture, uv3);
  
  vec2 uv4 = vec2(3.5 / textureWidth, (row + 0.5) / fMatrixTextureHeight);
  vec4 col3 = texture2D(uMatrixTexture, uv4);
  
  return mat4(col0, col1, col2, col3);
}

void main() {
  vIsExtendedPoint = 0.0;
  vIntensityFloat = intensity;

  vBoxIndexFloat = -1.0;
  vec3 world_point_position = (modelMatrix * vec4(position, 1.0)).xyz;

  for (int i = 0; i < uNumActiveBoxList; i++) {
    if (i >= MAX_BOX_LIST) break;

    // 월드 좌표를 로컬 좌표로 변환 (역행렬 사용)
    mat4 inverseMatrix = getMatrix(i);
    vec3 local_point = (inverseMatrix * vec4(world_point_position, 1.0)).xyz;

    // 박스 경계 내에 있는지 확인 (GPU에 최적화된 방식)
    // -halfSize <= point <= halfSize 인지 체크
    vec3 absPoint = abs(local_point);
    vec3 halfSize = uBoxHalfSizeList[i];
    
    // 모든 축(x, y, z)에 대해 경계 내부인지 확인
    // step(a, b)는 b >= a 일 때 1.0, 아니면 0.0 반환
    // 따라서 step(absPoint, halfSize)는 halfSize >= absPoint일 때 1.0을 반환
    // 즉, 점이 박스 내부에 있을 때(absPoint <= halfSize) 1.0을 반환
    float insideX = step(absPoint.x, halfSize.x);
    float insideY = step(absPoint.y, halfSize.y);
    float insideZ = step(absPoint.z, halfSize.z);

    if (
      !bIsMainView &&
      insideX * insideY == 1.0 &&
      insideZ != 1.0 &&
      absPoint.z >= 0.0
    ) {
      vIsExtendedEqualZAxis = 1.0;
    } else {
      vIsExtendedEqualZAxis = 0.0;  
    }
    
    // 모든 조건이 충족되면(모든 값이 1.0) 곱셈 결과는 1.0, 하나라도 실패하면 0.0
    float isInside = insideX * insideY * insideZ;

    if (isInside > 0.5) {
      vBoxIndexFloat = float(i);
      break;
    }
    
    // viewMode가 default가 아닌 경우, 확장된 영역(1m) 내부에 있는지 확인
    if (!bIsMainView) {
      // 확장된 경계(기존 halfSize + 1.0m)
      vec3 extendedHalfSize = halfSize + vec3(1.0, 1.0, 1.0);
      
      // 확장된 영역 내부인지 확인
      float extendedInsideX = step(absPoint.x, extendedHalfSize.x);
      float extendedInsideY = step(absPoint.y, extendedHalfSize.y);
      float extendedInsideZ = step(absPoint.z, extendedHalfSize.z);
      
      // 확장된 영역 내부에 있고 원래 박스 내부에는 없는 경우
      float isExtendedInside = extendedInsideX * extendedInsideY * extendedInsideZ * (1.0 - isInside);
      
      if (isExtendedInside > 0.5) {
        vBoxIndexFloat = float(i);
        vIsExtendedPoint = 1.0;  // 확장된 영역 내부의 점으로 표시
        break;
      }
    }
  }

  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  gl_PointSize = fSize;
}`;

export default vertexShader;
